import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('ads/', data));

/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('ads/', { data: ids }));

/**
 * get getAdInfo
 */
export const getAdInfo = id => axios.$callAPI(() => axios.get('/ads/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('ads/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('ads/' + id));
/**
 * get list
 */
// export const getList = data => axios.$callAPI(() => axios.get('ads/search', { params: data }));

/*export const getList = async data => {
    const AdData = (await axios.$callAPI(() => axios.get('ads/search', { params: data })));
    const ads = AdData.page.records;
   
    const adSpacesData = (await axios.$callAPI(() => axios.get('adSpaces/search', { size: '9999' })));
    const adSpaces = adSpacesData.page.records;
    let result = {};
    result.page = AdData.page;
    result.page.total = AdData.page.total;
    if (ads.length != 0) {
        for (let i = 0; i < ads.length; i++) {
            for (let j = 0; j < adSpaces.length; j++) {
                if (adSpaces[j].id === ads[i].spaceId) {
                    result.page.records[i].spaceName = adSpaces[j].name;
                    break;
                }
            }
        }
    }
    return result;
};*/

/**
 * get list
 */
export const getList = data => axios.$callAPI(() => axios.get('ads/search', { params: data }));
////////广告位
/**
 * get 广告位 list
 */
export const getAdSpaceList = data => axios.$callAPI(() => axios.get('adSpaces/search', { params: data }));

/**
 * get getAdSpaceInfo
 */
export const getAdSpaceInfo = id => axios.$callAPI(() => axios.get('/adSpaces/' + id));
